import React, { useEffect, useState } from "react";
import { getReimbursementList } from "../Services/PayrollService";

export const Reimbursements = ({ hideAmount }) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [reimbursementList, setReimbursementList] =  useState([]);

  useEffect(() => {
    fetchReimbursementList();
  }, []);

  async function fetchReimbursementList() {
    const req = {
      ReimbursementId: 0,
      LoggedInEmpId: userDetails.EmpId || 0,
      OrgId: userDetails.OrgId || 0,
      GUID: "",
      EmpId: userDetails.EmpId || 0,
      PageNumber: 1,
      PageSize: 25,
      Search: "",
      ReimbursementStatusId: "",
      ReimbursementTypeId: "",
    };

    try {
      const response = await getReimbursementList(req);
setReimbursementList(response?.Data?.ReimbursementItems || []);
      console.log(response, "response-----------");
    } catch (error) {
      console.error("Error fetching reimbursement list:", error);
    }
  }

  const renderAmt = (value) => {
    return hideAmount ? "•••••" : `₹${value.toLocaleString("en-IN")}`;
    // if (masked) {
    //   return <span style={{ letterSpacing: '2px' }}>••••••</span>;
    // }
    // return `₹${value.toLocaleString('en-IN')}`;
  };

  return (
    <div className="tab-panel active" id="tab-reimb">
      <div className="sec-card">
        <div className="sec-card-head">
          <i className="fa-solid fa-receipt text-brand"></i>
          <h6>My Reimbursements</h6>
          <span
            style={{
              marginLeft: "auto",
              fontSize: "11.5px",
              color: "var(--text-muted)",
            }}
          >
            Read only
          </span>
        </div>

        <div className="sec-card-body p0">
          <table className="ro-tbl">
            <thead>
              <tr>
                <th>Type</th>
                <th>Description</th>
                <th>Month</th>
                <th className="tr">Amount</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {reimbursementList?.map((r, index) => (
                <tr key={index}>
                  <td>
                    <span
                      className="badge badge-account"
                      style={{ fontSize: "10.5px" }}
                    >
                      {r?.ReimbursementTypeName}
                    </span>
                  </td>

                  <td style={{ fontSize: "12px", color: "var(--text-muted)" }}>
                    {r?.Desc}
                  </td>

                  <td style={{ fontSize: "12px", color: "var(--text-muted)" }}>
                    {r?.ForMonth}
                  </td>

                  <td className="tr" style={{ fontWeight: 700 }}>
                    {renderAmt(r?.Amount)}
                  </td>

                  <td>
                    <span
                      className={`badge badge-${r.ReimbursementStatusName?.toLowerCase()}`}
                      style={{ fontSize: "10.5px" }}
                    >
                      {r?.ReimbursementStatusName}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Future section */}
      {/* <div
        style={{
          padding: "14px 0",
          borderTop: "1px solid var(--border)",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <span style={{ fontSize: "12px", color: "var(--text-muted)" }}>
          Coming in a future phase:
        </span>

        <span className="future-btn" style={{ width: "auto", marginBottom: 0 }}>
          <i className="fa-solid fa-plus"></i> Submit Reimbursement Claim
        </span>
      </div> */}
    </div>
  );
};

export default Reimbursements;
